import { apiRequest } from './client';

export type ProductCategory = 'BED' | 'MATTRESS' | 'ACCESSORY';

export interface Product {
  id: string;
  name: string;
  slug: string;
  category: ProductCategory;
  shortDescription: string | null;
  description: string | null;
  specifications: Record<string, unknown> | null;
  imageUrl: string | null;
  images: string[];
  monthlyPrice: number;
  dailyPrice: number | null;
  minimumRentalDays: number;
  sortOrder: number;
  active: boolean;
  visibleOnWebsite: boolean;
  recommendedMattressTypeId: string | null;
  recommendedMattress: { id: string; name: string; slug: string } | null;
  recommendedForBeds: { id: string; name: string; slug: string }[];
  createdAt: string;
  updatedAt: string;
}

export interface ProductInput {
  name: string;
  slug?: string;
  category: ProductCategory;
  shortDescription?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  images?: string[];
  specifications?: Record<string, string> | null;
  monthlyPrice: number;
  dailyPrice?: number | null;
  minimumRentalDays?: number;
  sortOrder?: number;
  active?: boolean;
  visibleOnWebsite?: boolean;
  recommendedMattressTypeId?: string | null;
}

export const fetchPublicProducts = async (): Promise<Product[]> =>
  (await apiRequest<{ items: Product[] }>('/public/products')).items;

export const fetchPublicProduct = (slug: string): Promise<Product> =>
  apiRequest<Product>(`/public/products/${encodeURIComponent(slug)}`);

export const fetchProducts = async (filters: { category?: ProductCategory; active?: boolean } = {}): Promise<Product[]> => {
  const params = new URLSearchParams();
  if (filters.category) params.set('category', filters.category);
  if (filters.active !== undefined) params.set('active', String(filters.active));
  const query = params.toString();
  return (await apiRequest<{ items: Product[] }>(`/products${query ? `?${query}` : ''}`)).items;
};

export const fetchProduct = (id: string): Promise<Product> => apiRequest<Product>(`/products/${id}`);

export const createProduct = (input: ProductInput): Promise<Product> =>
  apiRequest<Product>('/products', { method: 'POST', body: input });

export const updateProduct = (id: string, input: Partial<ProductInput>): Promise<Product> =>
  apiRequest<Product>(`/products/${id}`, { method: 'PATCH', body: input });
